import { ExpertId, MergeSettings, SyncMergeSettings, AtsCandidatesPayload } from 'types/MergeIntegration';
import { post } from '../utilities';
import { API_URL_PREFIX, DEFAULT_TOKEN } from '../utilities/constants';


const getMergeSetting = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/get`, { ...payload, token: DEFAULT_TOKEN });
};

const postMergeSetting = (payload: MergeSettings) => {
    return post(`${API_URL_PREFIX}/merge/company/settings`, {
        ...payload, token: DEFAULT_TOKEN
    })
};

const deleteMergeSetting = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/delete`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const postSyncMergeSettings = (payload: SyncMergeSettings) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/sync`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const postMagicLink = (payload: ExpertId) => {
    return post(`${API_URL_PREFIX}/merge/company/settings/magicLink`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const getAtsCandidates = (payload: AtsCandidatesPayload) => {
    return post(`${API_URL_PREFIX}/ats/job/getCandidates`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const getSignedResumeUrl = (payload: {
    expertId: string;
    s3Url: string;
}) => {
    return post(`${API_URL_PREFIX}/ats/job/getSignedResumeUrl`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const getJobMatrix = (payload: {
    expertId: string;
    jobId: string;
}) => {
    return post(`${API_URL_PREFIX}/ats/job/getJobMatrix`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const updateJobDetails = (payload: {
    expertId: string;
    jobId: string;
    scoreThreshold: number;
    applyToExisting: boolean;
}) => {
    return post(`${API_URL_PREFIX}/ats/job/updateJobDetails`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

const addCandidatesToTalentPool = (payload: {
    expertId: string;
    jobId: string;
    candidateIds: string[];
}) => {
    return post(`${API_URL_PREFIX}/ats/job/addCandidatesToTalentPool`, {
        ...payload, token: DEFAULT_TOKEN
    })
}

export const mergeIntegrationService = {
    getMergeSetting,
    postMergeSetting,
    deleteMergeSetting,
    postSyncMergeSettings,
    postMagicLink,
    getAtsCandidates,
    getSignedResumeUrl,
    getJobMatrix,
    updateJobDetails,
    addCandidatesToTalentPool
}
